import { render } from "./RemindsMeCheckbox.vue?vue&type=template&id=8e805868&scoped=true"
import script from "./RemindsMeCheckbox.vue?vue&type=script&lang=ts"
export * from "./RemindsMeCheckbox.vue?vue&type=script&lang=ts"

import "./RemindsMeCheckbox.vue?vue&type=style&index=0&id=8e805868&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-8e805868"

export default script